import React, { useState } from 'react'
import { GalleryPageConfig } from '../configuration'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination } from 'swiper/core'
import { ClosePin, Plus } from '../icons'
import styles from './Gallery.module.sass'
import Container from '../Container'
import gallery1 from './assets/images/gallery1.jpg'
import gallery2 from './assets/images/gallery2.jpg'
import gallery3 from './assets/images/gallery3.jpg'
import slide1 from './assets/images/slide1.jpg'
import slide2 from './assets/images/slide2.jpg'
import slide3 from './assets/images/slide3.jpg'
import slide4 from './assets/images/slide4.jpg'
import AssignId from '../AssignId'
import VisibilitySensor from '../VisibilitySensor'
import { useMediaQuery } from '@material-ui/core'

SwiperCore.use([Pagination]);

export default function Gallery() {

  const items = [{ 
      key: 1, 
      image: gallery1, 
      points: [
        { 
          key: 11, 
          x: 50.5, 
          y: 30.4,
          xside: 'right',
          description: GalleryPageConfig.item1,
          variant: <><strong>SCAGLIE INCENSO - 60x120</strong> / 24"x48" R CERASILK</>
        },
      ]
    }, { 
      key: 2, 
      image: gallery2, 
      points: [
        { 
          key: 21, 
          x: 56.4, 
          y: 74.2, 
          yside: 'top',
          description: GalleryPageConfig.item2,
          variant: <><strong>LUCE - 120x120</strong> / 48"x48" R MATT-PRO</>
        },
        { 
          key: 22, 
          x: 80, 
          y: 51.6, 
          description: GalleryPageConfig.item3,
          variant: <><strong>SCAGLIE MULTICOLOR - 120x120</strong> / 48"x48" R CERASILK</>
        },
      ]
    }, { 
      key: 3, 
      image: gallery3, 
      points: [
        { 
          key: 32, 
          x: 36.4, 
          y: 78.2, 
          xside: 'right',
          yside: 'top',
          description: GalleryPageConfig.item4,
          variant: <><strong>SCAGLIE FUMO - 120x120</strong> / 48"x48" R CERASILK</>
        },
        { 
          key: 31, 
          x: 74.4,
          y: 53.4, 
          xside: 'right',
          description: GalleryPageConfig.item5,
          variant: <><strong>SCAGLIE FUMO - 60x120</strong> / 24"x48" R CERASILK</>
        },
      ]
    }, 
    { 
      key: 4, 
      image: slide1, 
      points: [
        { 
          key: 41, 
          x: 44,
          y: 79,
          yside: 'top',
          description: GalleryPageConfig.item6,
          variant: <><strong>INCENSO - 120x120</strong> / 48"x48" R</>
        },
        { 
          key: 42, 
          x: 72,
          y: 64,
          description: GalleryPageConfig.item7,
          variant: <><strong>INCENSO - 120x120</strong> / 48"x48" R</>
        },
      ]
    }, { 
      key: 5, 
      image: slide2, 
      points: [
        {
          key: 51, 
          x: 81,
          y: 21, 
          description: GalleryPageConfig.item8, 
          variant: <><strong>LUCE - 60x120</strong> / 24"x48" R</>
        },
      ]
    }, { 
      key: 6, 
      image: slide3, 
      points: [ 
        { 
          key: 61, 
          x: 36,
          y: 62,
          description: GalleryPageConfig.item9,
          variant: <><strong>FUMO - 120x120</strong> / 48"x48" R</>
        },
        {
          key: 62, 
          x: 78, 
          y: 74,
          description: GalleryPageConfig.item10,
          variant: <><strong>FUMO - 120x120</strong> / 48"x48" R</>
        },
      ]
    }, { 
      key: 7, 
      image: slide4, 
      points: [ 
        { 
          key: 71, 
          x: 70,
          y: 43, 
          description:GalleryPageConfig.item11, 
          variant: <><strong>FUMO - 120x120</strong> / 60"x60" R</>
        }
      ]
    }
  ]

  const [openPoint, setOpenPoint] = useState(null)
  const isMobile = useMediaQuery('(max-width: 760px)')

  return (
    <div className={styles.root}>
      <AssignId
        absolute
        y='-120px'
        yMobile='-80px'
        id={GalleryPageConfig.id}
      />
      <VisibilitySensor index={5} />
      <Container>
        <div className={`${styles.content} scroll-fadein`}>
          <p className={styles.intro}>{GalleryPageConfig.intro}</p>
          <h2 className={styles.title}>{GalleryPageConfig.title}</h2>
        </div>
      </Container>
      <div className={`${styles.slider} scroll-fadein-late`}>
        <Swiper 
          slidesPerView={1} 
          initialSlide={0}
          spaceBetween={40} 
          loop={isMobile}
          pagination={{ clickable: true }}
          className={styles.swiper}
          breakpoints={{
            768: {
              slidesPerView: "auto"
            }
          }}
        >
          {items.map(x => (
            <SwiperSlide key={x.key}>
              <div className={styles.item}>
                <img src={x.image} alt={x.alt} className={styles.itemImage} onClick={() => setOpenPoint(null)} />
                {x.points?.map(p => (
                  <div key={p.key} className={`${styles.point} ${p.xside ? styles[`point--${p.xside}`] : ""} ${p.yside ? styles[`point--${p.yside}`] : ""} ${openPoint?.key === p.key ? styles['point--open'] : ""}`} style={{ left: `${p.x}%`, top: `${p.y}%` }}>
                    <button className={styles.pointTrigger} onClick={() => setOpenPoint(openPoint ? null : p)} style={{ left: `${p.x}%`, top: `${p.y}%` }}>
                      <span className={styles.pointTriggerIcon}>
                        <Plus />
                      </span>
                    </button>
                    <div className={styles.pointContent}>
                      <button className={styles.pointClose} onClick={() => setOpenPoint(null)}>
                        <ClosePin />
                      </button>
                      <p className={styles.pointDescription}>
                        {p.description}
                      </p>
                      <p className={styles.pointVariant}>
                        {p.variant}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}
